import { publishTimes } from '../../../ScheduleView/shared';
import dayjs from 'dayjs';

export const getPublishTime = (publicationDate: string, publicationType: publishTimes): string => {
  if (publicationType === publishTimes.NOW) {
    return 'Publish Now';
  }
  return dayjs(publicationDate).format('DD/MM/YYYY HH:mm');
};
